import { render, staticRenderFns } from "./AccidentReport.vue?vue&type=template&id=698db729&scoped=true&"
import script from "./AccidentReport.vue?vue&type=script&lang=js&"
export * from "./AccidentReport.vue?vue&type=script&lang=js&"
import style0 from "./AccidentReport.vue?vue&type=style&index=0&id=698db729&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698db729",
  null
  
)

export default component.exports